import { render, staticRenderFns } from "./FacebookMessengerIcon.vue?vue&type=template&id=30f9571a&"
import script from "./FacebookMessengerIcon.vue?vue&type=script&lang=js&"
export * from "./FacebookMessengerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports